module.exports = __webpack_public_path__ + "img/sidebar-icon-timesheet.e7a4fd45.svg";